import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';

import { MatMenuModule, MatMenu } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface SmallIconMenuAction {
  icon: string;
  action: string;
  label?: string;
}

@Component({
  selector: 'app-small-icon-menu',
  standalone: true,
  imports: [
    MatMenuModule,
    MatButtonModule,
    MatIconModule
],
  templateUrl: './small-icon-menu.component.html',
  styleUrls: ['./small-icon-menu.component.scss']
})
export class SmallIconMenuComponent {
  @Input() menuId: string = 'iconMenu';
  @Input() yPosition: 'above' | 'below' = 'above';
  @Input() xPosition: 'before' | 'after' = 'after';
  @Input() actions?: SmallIconMenuAction[]; // Custom actions, ha nincs megadva akkor defaultActions
  @Input() canEdit: boolean = false; // Edit ikon megjelenítése
  @Input() chipCreatedBy?: number | null; // Chip létrehozója (createdby)
  @Input() currentUserId?: number; // Bejelentkezett felhasználó ID
  @Input() isAdmin: boolean = false; // Admin role
  
  @Output() actionClicked = new EventEmitter<SmallIconMenuAction>();
  
  @ViewChild('iconMenu', { static: true }) iconMenu!: MatMenu;
  
  // Getter for external access to the menu (MatMenuTrigger compatibility)
  get menu(): MatMenu {
    return this.iconMenu;
  }

  // Default actions for chip menus
  readonly defaultActions: SmallIconMenuAction[] = [
    { icon: 'content_copy', action: 'copy', label: 'Másolás' },
    { icon: 'check', action: 'complete', label: 'Befejezés' },
    { icon: 'close', action: 'reject', label: 'Elutasítás' }
  ];

  // Get actions to display (custom or default)
  get displayActions(): SmallIconMenuAction[] {
    const baseActions = this.actions || this.defaultActions;
    
    // Edit ikon hozzáadása ha engedélyezett
    if (this.shouldShowEdit()) {
      return [
        { icon: 'edit', action: 'edit', label: 'Szerkesztés' },
        ...baseActions
      ];
    }
    
    return baseActions;
  }
  
  // Edit ikon megjelenítésének ellenőrzése
  private shouldShowEdit(): boolean {
    if (!this.canEdit) return false;
    // Ha chipCreatedBy null vagy undefined (nincs createdby adat), nincs edit
    if (this.chipCreatedBy == null) return false;
    if (this.isAdmin) return true; // Admin mindig szerkeszthet
    if (this.currentUserId && this.chipCreatedBy === this.currentUserId) return true; // Saját customer
    return false;
  }

  onActionClick(action: SmallIconMenuAction, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.actionClicked.emit(action);
  }
}